import { USER_PROFILE_GROUPS_REMOVE_REQUEST, USER_PROFILE_GROUPS_REMOVE_SUCCESS, USER_PROFILE_GROUPS_REMOVE_FAILURE } from '../../constants/user_profile_groups.constants';

export const userProfileGroupsRemoveRequest = (user_id, del_groups) => ({
    type: USER_PROFILE_GROUPS_REMOVE_REQUEST, user_id, del_groups,
});

export const userProfileGroupsRemoveSuccess = payload => ({
    type: USER_PROFILE_GROUPS_REMOVE_SUCCESS, payload,
});

export const userProfileGroupsRemoveFailure = error => ({
    type: USER_PROFILE_GROUPS_REMOVE_FAILURE, error,
});



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/actions/user_profile_groups_actions/user_profile_groups_remove.actions.js